import { RouteObject } from 'react-router-dom';
import Home from '../pages';
import CreatorForm from '../pages/creator-form';
import Success from '../pages/success';
import AlreadySubmitted from '../pages/already-submitted';

export const publicRoutes: RouteObject[] = [
  {
    path: '/:subdomainSuffix',
    element: <Home />,
  },
  {
    path: '/:subdomainSuffix/creator-form',
    element: <CreatorForm />,
  },
  {
    path: '/:subdomainSuffix/success',
    element: <Success />,
  },
  {
    path: '/:subdomainSuffix/already-submitted',
    element: <AlreadySubmitted />,
  },
];
